// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".infos-rwd[data-v-522ed485] {\n  height: 100%;\n}\n.infos-rwd .title[data-v-522ed485] {\n  position: absolute;\n  bottom: 20px;\n  width: 90%;\n  left: 50%;\n  transform: translateX(-50%);\n}", ""]);
// Exports
module.exports = exports;
